import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sourceLang: 'fr',
  targetLangs: ['en'],
  targetLang: 'en',
  mode: 'single',
  inputType: 'text', // 'text' or 'file'
  textValue: '',
  fileValue: null,
  inputFilePath: '',
  outputFilePath: '',
};

export const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    updateData(state, action) {
      state.sourceLang = action.payload.sourceLang;
      state.targetLang = action.payload.targetLang;
      state.targetLangs = action.payload.targetLangs;
      state.mode = action.payload.mode;
      state.inputType = action.payload.inputType;
      state.textValue = action.payload.textValue;
      state.fileValue = action.payload.fileValue;
      state.inputFilePath = action.payload.inputFilePath;
      state.outputFilePath = action.payload.outputFilePath;
    },
  },
});

export const { updateData } = translationSlice.actions;
export default translationSlice.reducer;
